export const experienceData = [
  {
    id: 1,
    company: "WebNeo Tech Corporation, Calgary",
    jobtitle: "Founder & AI Automation Engineer",
    startYear: "2023",
    endYear: "Present (Calgary)",
    description:
      "Building AI lead recovery and CRM automation systems for Calgary businesses.",
  },
  {
    id: 2,
    company: "Global iTech Systems Ltd., Calgary",
    jobtitle: "Full-Stack Developer & Technical Lead",
    startYear: "2021",
    endYear: "2023 (Calgary)",
    description:
      "First Calgary role. Led end-to-end web application development for clients across North America. Owned projects from architecture through production deployment.",
  },
  {
    id: 3,
    company: "Shopify (Self-employed)",
    jobtitle: "Web Designer & Market Analyst",
    startYear: "2018",
    endYear: "2021 (Self-employed)",
    description:
      "Designed and built complete Shopify storefronts. Handled design, product content, payment integration, and analytics independently.",
  },
  {
    id: 4,
    company: "EKbana Solutions, Kathmandu",
    jobtitle: "Web Developer",
    startYear: "2017",
    endYear: "2018",
    description:
      "First professional role. Built full-stack web apps for non-profits and e-commerce companies in Nepal.",
  },
];
